import apiClient from 'helpers/api-client'
import { StateCreator } from 'zustand'
import { IBankList } from './interface'

export const createBankListSlice: StateCreator<IBankList> = (
  set,
) => ({
  // state
  isLoadingBankList: false,
  bankList: [],
  // actions
  getBankList: async () => {
    try {
      set({ isLoadingBankList: true })
      const res = await apiClient.get('/user/hub/v1/bank')
      if (res?.data?.code === 'SUCCESS') {
        set({
          bankList: res?.data?.data,
        })
      }
      set({ isLoadingBankList: false })
    } catch (error) {
      set({ isLoadingBankList: false })
      console.error(error)
    }
  },
})
